export default __webpack_public_path__ + "static/media/fashion2.3d61c6df.png";